import { memo, useCallback } from 'react';
import type { Item } from '../types';
import './ItemCard.css';

interface ItemCardProps {
  item: Item;
  isSelected: boolean;
  onToggle: (id: string) => void;
}

export const ItemCard = memo(function ItemCard({ item, isSelected, onToggle }: ItemCardProps) {
  const handleToggle = useCallback(() => {
    onToggle(item.id);
  }, [onToggle, item.id]);

  const handleCheckboxClick = useCallback((e: React.MouseEvent) => {
    e.stopPropagation();
  }, []);

  return (
    <div
      className={`item-card-mini ${isSelected ? 'selected' : ''}`}
      onClick={handleToggle}
    >
      <div className="item-card-mini-header">
        <h3>{item.name}</h3>
      </div>
      <div className="item-card-mini-meta">
        <span className="item-type">{item.type}</span>
        <span className="item-rarity" data-rarity={item.rarity}>{item.rarity}</span>
      </div>
      <input
        type="checkbox"
        checked={isSelected}
        onChange={handleToggle}
        onClick={handleCheckboxClick}
        className="item-checkbox"
        aria-label={`Select ${item.name} for print`}
      />
    </div>
  );
});
